<div class="__wrapper">
  <div class="__header d-flex justify-content-between align-items-center">
    <div class="__header-left-pane overflow-hidden">
      <ng-content select="[header-left-pane]"></ng-content>
    </div>
    <div class="__header-right-pane d-flex justify-content-end align-items-center">
      <ng-content select="[header-right-pane]"></ng-content>
      <app-button
        class="--only-icon --small --primary-dark"
        icon="rmv-icon-ic-close"
        (clickEvent)="closeEvent.emit($event)"
      ></app-button>
    </div>
  </div>
  <div class="__content">
    <ng-content></ng-content>
  </div>
  <div class="__footer">
    <ng-content select="[footer]"></ng-content>
  </div>
</div>